export const autoComplete = () =>
{
    function autocomplete(inp) {
        inp.addEventListener("input", function (e) {
            var term = this.value;
            console.log(term);
            fetch("umbraco/surface/Autocomplete/GetSuggestions?term=" + term)
                .then(response => response.json())
                .then(data => {
                    var suggestionsContainer = document.getElementById("suggestionsContainer");
                    suggestionsContainer.innerHTML = "";
                    if (typeof data !== "string") {
                        
                        var urls = data.url;
                        var names = data.name;
                        var classes = data.itemType;
                        var totalItems = data.totalItems;
                        var itemsShown = data.itemsShown;
                        var ul = document.createElement("ul");
                        ul.classList.add("autocomplete-list");
                        console.log(classes);
                        for (var i = 0; i < urls.length; i++) {
                            if (!Object.is(urls[i], null)) {
                                console.log(urls[i]);
                                var li = document.createElement("li");
                                li.classList.add("autocomplete-list__item");
                                li.classList.add(classes[i]);

                                var a = document.createElement("a");
                                a.classList.add("autocomplete-list__url");
                                a.setAttribute('href', urls[i]);
                                a.setAttribute('role', "button");
                                a.setAttribute('tabindex', '0');
                                a.textContent = names[i];


                                //// Add click event listener here
                                //a.addEventListener('click', function (e) {
                                //    e.preventDefault(); // Prevent default action
                                //    window.location.href = this.getAttribute('href'); // Navigate explicitly
                                //});


                                li.appendChild(a);
                                ul.appendChild(li);
                            }
                        }
                        var lastItemOfEachClass = {};
                        for (var i = 0; i < classes.length; i++) {
                            if (!lastItemOfEachClass[classes[i]]) {
                                lastItemOfEachClass[classes[i]] = { index: i };
                            }
                            else {
                                lastItemOfEachClass[classes[i]].index = i;
                            }
                        }
                        var y = 0;
                        for (var className in lastItemOfEachClass) {
                            var lastIndex = lastItemOfEachClass[className].index;
                            var liElement = ul.children[lastIndex];
                            var countSpan = document.createElement("span");
                            countSpan.classList.add("autocomplete-list__count");
                            countSpan.textContent = `Visar ${itemsShown[y]} av ${totalItems[y]} tr\u00E4ffar`;

                            liElement.appendChild(countSpan);
                            y++;
                        }

                        suggestionsContainer.appendChild(ul);
                    }
                })
                .catch(error => {
                    // Handle error
                    console.error(error);
                });
        });
    }

    document.addEventListener("DOMContentLoaded", function () {
        autocomplete(document.getElementById("searchInput"));
    });

    var searchButton = document.querySelector('.main-search__search-button');

    //searchButton.addEventListener('click', function (event) {
    //    console.log('clicked');
    //});

    document.addEventListener('click', function(event) {
        // Check if the clicked element is not the search input
        if (!event.target.matches('.main-search--menu-search .search-form')) {
          // If it's not the search input, clear its value
            document.getElementById('searchInput').value = '';
            document.getElementById('suggestionsContainer').innerHTML = "";
        }
      });

    //alert('test');

    document.addEventListener('DOMContentLoaded', function () {
        // Get the elements
        var searchButton = document.querySelector('.main-search__search-button');
        var formElement = document.querySelector('.main-search--menu-search');
        var searchListItem = document.querySelector('.main-navigation__item--search');
        var searchInput = document.querySelector('.main-navigation__item--search .search-form');

        // Function to add aria-expanded attribute
        function expandForm() {
            formElement.setAttribute('aria-expanded', 'true');
            searchInput.focus();
        }

        // Function to remove aria-expanded attribute
        function collapseForm(event) {
            if (!searchListItem.contains(event.target)) {
                formElement.setAttribute('aria-expanded', 'false');
                searchInput.blur();
            }
        }

        // Add event listener to the search button
        searchButton.addEventListener('click', function (event) {
            console.log('expand');
            event.stopPropagation(); // Prevent click event from bubbling up
            expandForm();
        });

        // Add event listener to the document to catch clicks outside the form
        document.addEventListener('click', function (event) {
            console.log('collapse');
            collapseForm(event);
        });

        // Optional: prevent clicks within the search form from closing it
        searchListItem.addEventListener('click', function (event) {
            event.stopPropagation();
        });
    });
    
    
};